import React from 'react';
import { getMediaUrl, MediaConfig } from '@musedrops/shared';
import { AudioFileField } from '../../../shared/components/forms/AudioFileField';

interface OutroMusicSectionProps {
  showSlug: string;
  showId?: string;
  outroMusicUpdatedAt?: string | null;
  onOutroMusicDeleted?: () => void;
  // eslint-disable-next-line no-unused-vars
  onOutroMusicUpdatedAtChanged?: (timestamp: string) => void;
}

/**
 * Outro Music Section Component
 *
 * Wrapper around AudioFileField for show outro music.
 * Uses conventional filename from MediaConfig.
 */
export const OutroMusicSection: React.FC<OutroMusicSectionProps> = ({
  showSlug,
  showId,
  outroMusicUpdatedAt,
  onOutroMusicDeleted,
  onOutroMusicUpdatedAtChanged,
}) => {
  const outroMusicFile = MediaConfig.show.outroMusic; // 'outro.mp3'

  // Construct audio URL with timestamp for cache-busting
  const audioUrl = React.useMemo(() => {
    if (showSlug && outroMusicUpdatedAt) {
      return `${getMediaUrl('shows', showSlug, outroMusicFile)}?t=${new Date(outroMusicUpdatedAt).getTime()}`;
    }
    if (showSlug) {
      return getMediaUrl('shows', showSlug, outroMusicFile);
    }
    return undefined;
  }, [showSlug, outroMusicUpdatedAt, outroMusicFile]);

  return (
    <AudioFileField
      label="Outro Music"
      value={outroMusicUpdatedAt ? outroMusicFile : null} // Show filename if file exists (timestamp present)
      onUpload={() => {
        // No-op handler - just enables upload button. Timestamp update handled by onTimestampChanged.
      }}
      onDelete={onOutroMusicDeleted}
      onTimestampChanged={onOutroMusicUpdatedAtChanged}
      audioUrl={audioUrl}
      storageFolder="shows"
      slug={showSlug}
      entityId={showId}
      tableName="shows"
      fileType="outroMusic"
      accept="audio/*"
      uploadTitle="Upload Outro Music"
    />
  );
};
